import { useTranslation } from 'react-i18next'
import { useRef } from 'react'
import { CircularProgress, Typography } from '@material-ui/core'
import { Modal, ModalProps } from 'components/layout/Modal/Modal'
import { KnowledgeBaseContentForm } from 'components/forms/KnowledgeBaseContentForm/KnowledgeBaseContentForm'
import { KnowledgeBaseContentFormFields } from 'components/forms/KnowledgeBaseContentForm/types'
import * as Styled from './KnowledgeBaseContentModal.styles'

interface KnowledgeBaseContentModalProps extends Omit<ModalProps, 'children' | 'onClose'> {
  initialValues?: KnowledgeBaseContentFormFields
  initialDestination?: number
  destinationPlaceholder?: string
  onSave?: (values: KnowledgeBaseContentFormFields, languageCode: string) => void
  isLoading?: boolean
  isError?: boolean
  open: boolean
  isEdit?: boolean
  onClose: () => void
  isDataLoading?: boolean
  isDataError?: boolean
}

const KnowledgeBaseContentModal: React.FC<KnowledgeBaseContentModalProps> = ({
  initialValues,
  initialDestination,
  destinationPlaceholder,
  isError,
  isLoading,
  onSave: handleSave,
  open,
  isEdit,
  onClose: handleClose,
  isDataLoading,
  isDataError,
}) => {
  const {
    t,
  } = useTranslation()

  const handleCloseModal = () => {
    handleClose()
  }

  const submitRef = useRef<() => void>(() => {})

  return (
    <Styled.Modal open={open} onClose={handleCloseModal}>
      <Modal.Title variant='h3'>{t('knowledgeBase.content')}</Modal.Title>
      <Styled.ModalContent>
        {isDataError || isDataLoading ? (
          <Styled.HelpersContainer>
            {isDataError && <Typography color='error'>{t('common.errors.generic')}</Typography>}
            {isDataLoading && <CircularProgress color='primary' />}
          </Styled.HelpersContainer>
        ) : (
          <KnowledgeBaseContentForm
            initialValues={initialValues}
            initialDestination={initialDestination}
            destinationPlaceholder={destinationPlaceholder}
            isError={isError}
            isLoading={isLoading}
            onSubmit={handleSave}
            submitRef={submitRef}
          />
        )}
      </Styled.ModalContent>
      <Modal.Actions
        isLoading={isLoading}
        isSaveDisabled={isError}
        onCancel={handleCloseModal}
        onSave={() => submitRef.current()}
        confirmLabel={t(`common.${isEdit ? 'edit' : 'create'}`)}
      />
    </Styled.Modal>
  )
}

export { KnowledgeBaseContentModal }
